module.exports = __webpack_public_path__ + "static/media/tkflag.56a910da.svg";